// User preferences validation -- iteration 073
import { z } from "zod";

export const notificationPreferencesSchema = z.object({
  event_reminders: z.boolean().optional(),
  score_updates: z.boolean().optional(),
  messages: z.boolean().optional(),
  school_announcements: z.boolean().optional(),
});

export const updateUserPreferenceSchema = z.object({
  followed_school_ids: z.array(z.string()).optional(),
  sport_ids: z.array(z.string()).optional(),
  age_group_ids: z.array(z.string()).optional(),
  notification_preferences: notificationPreferencesSchema.optional(),
});

export type UpdateUserPreferenceInput = z.infer<typeof updateUserPreferenceSchema>;
